import { gql } from '@apollo/client';
import { AnalysisVisitFieldsFragment } from './fragments';

export const SEARCH_ANALYSIS_VISITS = gql`
  query SearchAnalysisVisits(
    $queryTypes: [QueryType!]
    $statuses: [AnalysisStatus]
    $pagination: Pagination!
    $schemaIds: [ID!]
  ) {
    searchAnalysisVisits(
      queryTypes: $queryTypes
      pagination: $pagination
      statuses: $statuses
      schemaIds: $schemaIds
    ) {
      entities {
        ...AnalysisVisitFields
      }
    }
  }
  ${AnalysisVisitFieldsFragment}
`;
